import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const LOGIN_REDIRECT_REASON_STORAGE_KEY = 'rh_login_redirect_reason';

type AuthGateProps = {
  children: React.ReactNode;
};

export function AuthGate({ children }: AuthGateProps) {
  const location = useLocation();
  const { user, isBootstrapping } = useAuth();

  if (isBootstrapping) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-background text-muted-foreground">
        <span className="flex items-center gap-2 text-sm font-medium">
          <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
          Loading…
        </span>
      </div>
    );
  }

  if (!user) {
    let reason: string | undefined;
    if (typeof window !== 'undefined' && window?.sessionStorage) {
      try {
        const stored = window.sessionStorage.getItem(LOGIN_REDIRECT_REASON_STORAGE_KEY) || '';
        reason = stored.trim() || undefined;
      } catch {
        // Ignore storage read failures.
      }
    }

    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: `${location.pathname}${location.search}${location.hash}`,
          ...(reason ? { reason } : null),
        }}
      />
    );
  }

  return <>{children}</>;
}

export default AuthGate;
